var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThirdBlackHexagon = function SvgThirdBlackHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 390,
    fill: "none",
    viewBox: "0 0 120 390"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3144",
    strokeWidth: 6,
    d: "M115.953 128.3 82.266 319.353l-182.301 66.352-148.612-124.701 33.687-191.052L-32.66 3.6z",
    clipRule: "evenodd"
  })));
};
export default SvgThirdBlackHexagon;